<template lang="pug">
    router-link.col-md-4.col-lg-4.col-sm-4(:to="link")
        .textbox.no-margin
            .textbox__image
                img(:src="image")
                .textbox-image-title {{ lenguage.title }}
            .textbox__body
                .textbox__description(style="color: #7d7d7d")
                    | {{ lenguage.content }}
</template>

<script>
export default {
    props: ["image", "lenguage", "link"]
}
</script>


// WEBPACK FOOTER //
// src/components/atoms/PmHomeCard.vue